module.exports = __webpack_public_path__ + "img/DSC_2898.303d1b4a.png";